import { Route } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

// Lazy imports
const DashboardPrincipalDirector = lazy(() => import("../layouts/director/DashboardPrincipalDirector"));
const DashboardWarehouse = lazy(() => import("../layouts/director/warehouse/DashboardWarehouse"));
const Createwarehouse = lazy(() => import("../layouts/director/warehouse/actions/CreateWarehouse"));

const CreateProduct = lazy(() => import("../layouts/director/product/actions/CreateProduct"));
const EditProduct = lazy(() => import("../layouts/director/product/actions/EditProduct"));

const CreateStore = lazy(() => import("../layouts/director/store/actions/CreateStore"));
const StoreDetails = lazy(() => import("../layouts/director/store/actions/StoreDetails"));
const EditStore = lazy(() => import("../layouts/director/store/actions/EditStore"));

const EditSupplier = lazy(() => import("../layouts/director/supplier/actions/EditSupplier"));
const CreateSupplier = lazy(() => import("../layouts/director/supplier/actions/CreateSupplier"));

const CreateInventory = lazy(() => import("../layouts/director/inventory/CreateInventory"));

const DashboardOperator = lazy(() => import("../layouts/director/operator/DashboardOperator"));
const CreateOperator = lazy(() => import("../layouts/director/operator/actions/CreateOperator"));
const EditOperator = lazy(() => import("../layouts/director/operator/actions/EditOperator"));

const EditMovement = lazy(() => import("../layouts/director/movement/EditMovement"));

const CreateExternalClient = lazy(() => import("../layouts/director/externalClient/actions/CreateExternalClient"));
const ViewExternalClient = lazy(() => import("../layouts/director/externalClient/actions/ViewExternalClient"));
const EditExternalClient = lazy(() => import("../layouts/director/externalClient/actions/EditExternalClient"));
const DeleteExternalClient = lazy(() => import("../layouts/director/externalClient/actions/DeleteExternalClient"));

export default function DirectorRoutes() {
  return (
    <>
      <Route
        path="/home/director"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <DashboardPrincipalDirector />
          </ProtectedRoute>
        }
      />

      {/* ALMACENES Y SUS ZONAS */}
      <Route
        path="/warehouses"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <DashboardWarehouse />
          </ProtectedRoute>
        }
      />
      <Route
        path="/warehouses/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <Createwarehouse />
          </ProtectedRoute>
        }
      />
      <Route
        path="/warehouses/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <Createwarehouse />
          </ProtectedRoute>
        }
      />

      {/* PRODUCTOS */}
      <Route
        path="/products/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <CreateProduct />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <EditProduct />
          </ProtectedRoute>
        }
      />

      {/* TIENDAS */}
      <Route
        path="/stores/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <CreateStore />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stores/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <StoreDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stores/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <EditStore />
          </ProtectedRoute>
        }
      />

      {/* PROVEEDORES */}
      <Route
        path="/suppliers/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <CreateSupplier />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suppliers/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <EditSupplier />
          </ProtectedRoute>
        }
      />

      {/* INVENTARIO */}
      <Route
        path="/inventory/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <CreateInventory />
          </ProtectedRoute>
        }
      />

      {/* OPERADORES */}
      <Route
        path="/operators"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <DashboardOperator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operators/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <CreateOperator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operators/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <EditOperator />
          </ProtectedRoute>
        }
      />

      {/* MOVIMIENTOS - EDITAR */}
      <Route
        path="/movement/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <EditMovement />
          </ProtectedRoute>
        }
      />

      {/* CLIENTES EXTERNOS */}
      <Route
        path="/external-clients/create"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <CreateExternalClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/external-clients/edit/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <EditExternalClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/external-clients/delete/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR"]}>
            <DeleteExternalClient />
          </ProtectedRoute>
        }
      />
      <Route
        path="/external-clients/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <ViewExternalClient />
          </ProtectedRoute>
        }
      />
    </>
  );
}
